import anime from 'animejs/lib/anime.es.js';

function find_parent_li(root, element) {
    if (element.parentNode) {
        if (element.parentNode.tagName == "LI" && element.parentNode.parentNode == root) {
            return element.parentNode;
        } else if (element.parentNode.tagName == "UL" || element.parentNode.tagName == "BODY") {
            return null;
        } else {
            return find_parent_li(element.parentNode);
        }
    }

    return null;
}

function clear_class(list, selector) {
    for (let i = 0; i < list.length; i += 1) {
        let it = list[i];
        it.classList.remove(selector);
    }
}

function CardStack_goto(ctx, index) {
    console.assert(ctx.cards, "No cards");
    console.assert(index >= 0 && index < ctx.cards.length, "Index is out of bounds");

    if (index == ctx.active_index) { return; }

    let active_index = ctx.active_index;
    let caption_next = ctx.nav_items[active_index].querySelector('.js-StackNav-item-caption');
    let caption_curr = ctx.nav_items[index].querySelector('.js-StackNav-item-caption');

    // @NOTE(Grey): If there is an existing active wipe, seek it to the end
    // so we don't leave any weird jitter
    if (ctx.active_wipe) {
        ctx.active_wipe.seek(ctx.active_wipe.duration)
    }
    ctx.active_wipe = anime.timeline({
        defaults: { duration: 600, easing: 'easeInOutCubic' },
    });


    ctx.active_wipe
        .add({
            targets: ctx.cards[ctx.active_index],
            clipPath: [ 'xywh(0 0 100% 100%)', 'xywh(100% 0 100% 100%)' ],
            begin: function() {
                ctx.nav_items[index].querySelector('.js-CardStack-nav-item-link').classList.add('is-active');
                ctx.nav_items[active_index].querySelector('.js-CardStack-nav-item-link').classList.remove('is-active');

                ctx.nav_items[index].classList.add('is-active');
                ctx.nav_items[active_index].classList.remove('is-active');

                ctx.cards[index].classList.add('is-active');
            },
            complete: function() {
                ctx.cards[active_index].classList.remove('is-active');
            },
        })
        .add({
            targets: ctx.cards[index],
            translateY: [ 24, 0 ],
            clipPath: [ 'xywh(0 0 0 100%)', 'xywh(0 0 100% 100%)' ],
        }, 0)

        if (caption_next) {
            caption_next.removeAttribute('style');
            let caption_next_bb = caption_next.getBoundingClientRect();

            ctx.active_wipe.add({
                targets: caption_next,
                height: [caption_next_bb.height + 'px', 0],
                duration: 300,
                easing: 'easeInOutCubic',
            }, 0)
        }

        if (caption_curr) {
            caption_curr.removeAttribute('style');
            let caption_curr_bb = caption_curr.getBoundingClientRect();

            ctx.active_wipe.add({
                targets: caption_curr,
                height: [0, caption_curr_bb.height + 'px'],
                duration: 300,
                easing: 'easeInOutCubic',
            }, 0);
        }

    ctx.active_index = index;
}

function CardStack_init(el) {
    if (el == null) { return; }

    let card_stack = {
        root: el,
        nav: el.querySelector('.js-CardStack-nav'),
        nav_items: el.querySelectorAll('.js-CardStack-nav-item'),
        cards: el.querySelectorAll('.js-CardStack-stack-card'),
        active_index: 0,
        active_wipe: null,
    };

    for (let i = 0; i < card_stack.nav_items.length; i += 1) {
        let link = card_stack.nav_items[i].querySelector('.js-CardStack-nav-item-link');
        let caption = card_stack.nav_items[i].querySelector('.js-StackNav-item-caption');

        if (!link.classList.contains('is-active')) {
            caption.style.height = 0;
        }
    }

    card_stack.nav.addEventListener('click', function(event) {
        let child = null; // find_parent_li(card_stack.nav, event.target)

        let path = event.composedPath();
        let nav_index = path.indexOf(card_stack.nav);
        let caption_link_clicked = false;

        path.forEach(function(it, index) {
            if (it.classList && it.classList.contains('js-StackNav-item-caption-link')) {
                caption_link_clicked = true;
            }
        });

        if (!caption_link_clicked) {
            event.preventDefault();

            if (nav_index >= 0 && path[nav_index - 1]) {
                if (path[nav_index - 1].tagName == "LI") {
                    child = path[nav_index - 1];
                }
            }

            if (child) {
                let index = Array.prototype.indexOf.call(card_stack.nav_items, child);

                if (index >= 0) {
                    CardStack_goto(card_stack, index);
                } else {
                    console.warn('not in nav');
                }
            } else {
                console.warn('no child found');
            }
        }
    });

    window.addEventListener('keyup', function(event) {
        let index = card_stack.active_index;
        if (event.key === 'ArrowRight') {
            index = (card_stack.active_index + 1) % card_stack.nav_items.length;
        } else if (event.key === 'ArrowLeft') {
            index = (card_stack.active_index + (card_stack.nav_items.length - 1)) % card_stack.nav_items.length;
        }

        CardStack_goto(card_stack, index);
    })

    CardStack_goto(card_stack, 0);
}

let stack_navs = document.querySelectorAll('.js-CardStack')

for (let i = 0; i < stack_navs.length; i += 1) {
    CardStack_init(stack_navs[i]);
}

